import React, { useState } from "react";
import { observer } from "mobx-react";
import { Card } from "primereact/card";
import { Toolbar } from "primereact/toolbar";
import ScenarioToolbar from "./ScenarioToolbar";
import { ProgressBar } from "primereact/progressbar";
import { Scenario } from "../../api/firebase/types/scenario.types";
import ScenarioTable from "./ScenarioTable";

const ScenarioTableCard: React.FC = () => {
  const [selectedScenarios, setSelectedScenarios] = useState<Scenario[]>();
  const [showLoader, setShowLoader] = useState<boolean>(false);

  const onScenariosDeleted = () => {
    setSelectedScenarios(undefined);
    setShowLoader(false);
  };

  return (
    <Card className="scenario-tableview p-col">
      {showLoader && <ProgressBar mode="indeterminate" />}
      <Toolbar
        left={() => <h2>Szenarien</h2>}
        right={() => (
          <ScenarioToolbar
            scenariosToDelete={selectedScenarios}
            onDelete={onScenariosDeleted}
            showLoader={setShowLoader}
          />
        )}
      />
      <div className="p-fluid">
        <ScenarioTable
          selectedScenarios={selectedScenarios}
          setSelectedScenarios={setSelectedScenarios}
        />
      </div>
    </Card>
  );
};

export default observer(ScenarioTableCard);
